// Allow-list of Google Workspace domains that may sign in to Skafer.
// An unset var disables the check (open access); the default is Wagner's domain.
const DOMAINS = (import.meta.env.VITE_ALLOWED_GOOGLE_DOMAINS || 'wagnerskis.com')
  .split(',')
  .map((d: string) => d.trim().toLowerCase())
  .filter(Boolean);

const PERSONAL_DOMAINS = new Set(['gmail.com', 'googlemail.com']);

export interface DomainCheckResult {
  allowed: boolean;
  reason: 'ok' | 'not-workspace' | 'no-email' | 'restricted';
}

/**
 * Check whether a Google user may sign in to Skafer.
 *
 * The `hd` (hosted domain) claim is only present when the account belongs to
 * a Google Workspace domain. Personal Google accounts (gmail.com) omit it.
 */
export function checkAllowedDomain(user: { email?: string; hd?: string } | null | undefined): DomainCheckResult {
  if (DOMAINS.length === 0) return { allowed: true, reason: 'ok' };
  if (!user?.email) return { allowed: false, reason: 'no-email' };

  const hd = user.hd ? String(user.hd).toLowerCase() : undefined;
  if (!hd || PERSONAL_DOMAINS.has(hd)) return { allowed: false, reason: 'not-workspace' };
  if (!DOMAINS.includes(hd)) return { allowed: false, reason: 'restricted' };
  return { allowed: true, reason: 'ok' };
}

export const PERSONAL_ACCOUNT_ERROR =
  'That looks like a personal Google account. Sign in with your Wagner work account (pete@wagnerskis.com) — use the "Sign in with another account" option to pick the right one.';